import { __rest } from '../../_virtual/_tslib.js';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import InputField from './input-field.js';

/**
 * @component Inputs
 * @package Inputs
 * @document ../_docs/code/Input.editor.tsx
 * @document ../_docs/code/Input.import.tsx
 * @document ../_docs/code/Input.snippet.tsx
 */
const Input = forwardRef((_a, ref) => {
    var { type = 'text' } = _a, props = __rest(_a, ["type"]);
    switch (type) {
        case 'number':
        case 'text':
        case 'password':
        case 'creditCard':
        case 'tel':
        case 'date':
        case 'securityCode':
            return (jsx(InputField, Object.assign({ type: type, inputRef: ref }, props)));
        default:
            console.warn(`Warning: Native input type ${type} is not supported`);
            return jsx(InputField, Object.assign({ type: "text" }, props));
    }
});

export { Input, Input as default };
